import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";
import { language } from 'config';

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function PrivacyPolicy(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg").default} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <h2 className={classes.title}>{language.privacy_policy}</h2>
            <p className={classes.description}>{language.privacy_policy_para1}</p>
            <p className={classes.description}>{language.privacy_policy_para2}</p>
            <p className={classes.description}>{language.privacy_policy_para3}</p>
            <p className={classes.description}>{language.privacy_policy_para4}</p>
            <p className={classes.description}>{language.privacy_policy_para5}</p>
            
            <p className={classes.description}>{language.privacy_policy_para6}</p>
            <h3>Information Collection and Use</h3>
            <p className={classes.description}>{language.privacy_policy_para7}</p>
            <p>The app does use third party services that may collect information used to identify you.</p>

              <p>Link to privacy policy of third party service providers used by the app</p>
              <p> <a href="https://www.google.com/policies/privacy/">Google Play Services</a></p>
              <p> <a href="https://firebase.google.com/policies/analytics">Google Analytics for Firebase</a></p>
              <p> <a href="https://firebase.google.com/support/privacy/">Firebase Crashlytics</a></p>
              <p> <a href="https://www.facebook.com/about/privacy/update/printable">Facebook</a></p>
              <p> <a href="https://expo.io/privacy">Expo</a></p>

              <h3>Log Data</h3>
              <p className={classes.description}>{language.privacy_policy_para8}</p>
              <h3>Cookies</h3>
              <p className={classes.description}>{language.privacy_policy_para9}</p>
              <p className={classes.description}>{language.privacy_policy_para10}</p>
              <h3>Service Providers</h3>
              <p className={classes.description}>{language.privacy_policy_para11}</p>
              <ul>
                <li>To facilitate our Service</li>
                <li>To provide the Service on our behalf</li>
                <li>To perform Service-related services</li>
                <li>To assist us in analyzing how our Service is used.</li>
              </ul>
              <p className={classes.description}>{language.privacy_policy_para12}</p>
              <h3>Security</h3>
              <p className={classes.description}>{language.privacy_policy_para13}</p>
              <h3>Links to Other Sites</h3>
              <p className={classes.description}>{language.privacy_policy_para14}</p>
              <h3>Children’s Privacy</h3>
              <p className={classes.description}>{language.privacy_policy_para15}</p>
              <h3>Changes to This Privacy Policy</h3>
              <p className={classes.description}>{language.privacy_policy_para16}</p>
              <p className={classes.description}>This policy is effective as of 2021-11-02</p>
              <h3>Contact Us</h3>
              <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a href="mailto:appnewosd@gmail.com">appnewosd@gmail.com</a></p>
            <br/>
        </div>
        </div>

      <Footer />
    </div>
  );
}
